import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { closeModal } from "../../../../redux/actions/actions";

const POLL_MS = 3000;
const REVIEW_MESSAGE =
  "We received a Payr payment but could not confirm it automatically. Our team will check it; please don't pay again.";
const STOP_MESSAGES = {
  failed: "The Payr payment failed. Please try again or use another payment method.",
  amount_mismatch: REVIEW_MESSAGE,
  needs_review: REVIEW_MESSAGE,
  error: REVIEW_MESSAGE,
};

export default function PayrIframeModal({ data }) {
  const iframeUrl = data?.iframeUrl;
  const invoiceId = data?.invoiceId;
  // payr/status only knows real invoices; temp/booking payments are reconciled manually.
  const canPoll = !!iframeUrl && !!invoiceId && data?.invoiceType === "invoice";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stopMessage, setStopMessage] = useState(null);

  useEffect(() => {
    if (!canPoll) return undefined;
    let stopped = false;
    const timer = setInterval(async () => {
      try {
        const res = await axiosInstance.get(
          `${process.env.REACT_APP_BASE_URL}payment/payr/status`,
          {
            params: { invoice_id: invoiceId },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              XRefreshToken: `${localStorage.getItem("loginUser")}`,
            },
          }
        );
        if (stopped) return;
        const message = STOP_MESSAGES[res?.data?.status];
        if (message) {
          stopped = true;
          clearInterval(timer);
          setStopMessage(message);
          return;
        }
        if (!res?.data?.paid) return;
        stopped = true;
        clearInterval(timer);
        dispatch(closeModal());
        navigate(`/myinvoices?invoice_id=${res.data.invoice_id}&status=success`);
      } catch (e) {
        // Keep polling; a transient failure should not close the checkout.
      }
    }, POLL_MS);
    return () => {
      stopped = true;
      clearInterval(timer);
    };
  }, [canPoll, invoiceId, dispatch, navigate]);

  if (!iframeUrl) {
    return (
      <Typography sx={{ color: "#a94442", padding: "0.5rem" }}>
        Payr session is not available. Please try again.
      </Typography>
    );
  }

  if (stopMessage) {
    return (
      <Typography sx={{ color: "#a94442", padding: "0.5rem" }}>
        {stopMessage}
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", height: { xs: "70vh", md: "75vh" } }}>
      <iframe
        title="Payr Checkout"
        src={iframeUrl}
        allow="payment"
        style={{ width: "100%", height: "100%", border: 0, display: "block" }}
      />
    </Box>
  );
}
